import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SalesOrderModel } from 'models/SalesOrderModel';

interface InitialState {
  selectedSalesOrders: SalesOrderModel[];
}

const initialState: InitialState = {
  selectedSalesOrders: []
};

export const selectedSalesOrdersSlice = createSlice({
  name: 'selectedSalesOrders',
  initialState,
  reducers: {
    setSelectedSalesOrders: (state, { payload }: PayloadAction<SalesOrderModel[]>) => {
      state.selectedSalesOrders = payload;
    },
    addSelectedSalesOrder: (state, { payload }: PayloadAction<SalesOrderModel>) => {
      state.selectedSalesOrders = [...state.selectedSalesOrders, payload];
    },
    removeSelectedSalesOrder: (state, { payload }: PayloadAction<SalesOrderModel>) => {
      state.selectedSalesOrders = state.selectedSalesOrders.filter((item) => item.id !== payload.id);
    }
  }
});

export const { addSelectedSalesOrder, removeSelectedSalesOrder, setSelectedSalesOrders } = selectedSalesOrdersSlice.actions;
